import { render, staticRenderFns } from "./CadastroPerfil.vue?vue&type=template&id=7c4564c6&scoped=true&"
import script from "./CadastroPerfil.vue?vue&type=script&lang=js&"
export * from "./CadastroPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4564c6",
  null
  
)

export default component.exports